<template>
  <v-container>
    <Table
      module="ESD"
      title="ESD Audits"
      :items="allAudits"
      :headers="headers"
      :totalItems="totalItems"
      sortKey="auditDate"
    >
      <template v-slot:data="{props}">
        <td>{{localizeDate(props.item.auditDate, true)}}</td>
        <td>{{ props.item.auditor ? props.item.auditor.name : "" }}</td>
        <td>{{ props.item.employee ? props.item.employee.name : "" }}</td>
        <td
          :style="{color: props.item.response.yes ? 'green' : 'red' }"
        >{{props.item.response.yes ? 'PASSED' : 'FAILED'}}</td>
        <td>{{props.item.response.comments || ""}}</td>
        <td>
          <v-icon class="mr-2" small @click="editRow(props.item)">edit</v-icon>
          <v-icon small @click="deleteRow(props.item)">delete</v-icon>
        </td>
      </template>
    </Table>
    <Create v-model="createView" />

    <v-btn fab fixed bottom right icon color="secondary" @click="createView = true">
      <v-icon large>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Table from "@/components/app/Table";
import Create from "@/components/audits/esd/Create";
import Common from "@/mixins/Common";

export default {
  name: "ESD",

  components: {
    Table,
    Create
  },

  data() {
    return {
      createView: false,
      headers: [
        { text: "Audit Date", value: "auditDate" },
        { text: "Auditor", value: "auditor.name" },
        { text: "Employee", value: "employee.name" },
        { text: "Passed", value: "response.yes" },
        { text: "Comments", value: "response.comments", sortable: false },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },

  computed: {
    ...mapGetters({
      allAudits: "audits/getAllAudits",
      user: "app/getUser",
      totalItems: "audits/getTotalAudits"
    })
  },

  destroyed() {
    this.$store.commit("audits/setAllAudits", []);
  },

  mixins: [LoginCheck, Common],

  methods: {
    editRow(row) {
      if (
        this.user._groups.includes("Admins") ||
        this.user.displayName === row.auditor.name
      ) {
        this.createView = true;
        this.$store.commit("audits/setEditAudit", row);
      } else {
        window.alert(
          "You do not have permission to edit this. Please contact an Administrator or the Auditor."
        );
      }
    },
    async deleteRow(row) {
      if (
        this.user._groups.includes("Admins") ||
        this.user.displayName === row.auditor.name
      ) {
        let confirmText = `Are you sure you want to delete this? It can not be recovered!`;
        if (confirm(confirmText)) {
          await this.$store.dispatch("audits/delete", {
            module: "esd",
            id: row._id
          });
          await this.$store.dispatch("audits/getAllAudits", {
            rowsPerPage: 10,
            sortBy: "auditDate",
            descending: true,
            page: 1,
            from: null,
            to: null,
            search: null,
            module: "esd"
          });
        }
      } else {
        window.alert(
          "You do not have permission to delete this. Please contact an Administrator or the Auditor."
        );
      }
    }
  }
};
</script>
